import React, { useEffect, useState } from 'react';
import styles from './styles.module.sass';
import { useAppDispatch, useAppSelector } from 'hooks';
import { ECGActions, facilityActions } from 'utils/store';
import { FacilityResponseDto } from 'types/types';
import { Button } from 'components';
import { ButtonType, DataStatus } from 'types/enums';

const EcgAnalyzeScreen = () => {
  const dispatch = useAppDispatch();
  const { data: userData, status: userStatus } = useAppSelector((state) => state.user);
  const { accountFacilities, status: facilityStatus } = useAppSelector((state) => state.facility);
  const [activeFacilities, setActiveFacilities] = useState<null | FacilityResponseDto>(
    accountFacilities?.length ? accountFacilities[0] : null,
  );

  const isLoading = userStatus === DataStatus.LOADING || facilityStatus === DataStatus.LOADING;

  useEffect(() => {
    if (activeFacilities) {
      dispatch(ECGActions.getFacilitiesEcg({ id: activeFacilities.id, skip: 0, limit: 20 }));
    }
  }, [dispatch, activeFacilities]);

  useEffect(() => {
    if (userData?.id && !accountFacilities?.length) {
      dispatch(facilityActions.getFacilityByUserId(userData?.id));
    }
  }, [accountFacilities?.length, dispatch, userData?.id]);

  if (isLoading) {
    return <h2 className={styles.title}>Loading</h2>;
  }

  if (!accountFacilities || !accountFacilities?.length) {
    return <h2 className={styles.title}>There is no facility</h2>;
  }

  return (
    <div className={styles.container}>
      {<h2>Please choose active facility:</h2>}
      <div className={styles.button_container}>
        {accountFacilities.map((facility) => (
          <Button
            buttonType={facility.id === activeFacilities?.id ? ButtonType.PRIMARY : ButtonType.OUTLINE}
            key={facility.id}
            onClick={() => setActiveFacilities(facility)}
          >
            {facility.name}
          </Button>
        ))}
      </div>
    </div>
  );
};

export { EcgAnalyzeScreen };
